import _ from "lodash";

export function sleep(ms: number): Promise<void> {
    return new Promise((resolve) => {
        setTimeout(resolve, ms);
    });
}

/**
 * Sleep until the check returns a non-null, non-false value. Checks ever `ms`.
 */
export async function sleepUntil<T>(
    check: () => Promise<T | null | false>,
    ms: number
): Promise<T> {
    let count = 0;
    let result: T | null | false = null;

    while (_.isNil(result) || result === false) {
        result = await check();
        await sleep(ms);
        count++;
        if (count * ms > minutes(10)) {
            throw new Error("Process failed - process took more than 10 minutes");
        }
    }

    // if check doesn't return anything, the above code will throw an error.
    return result;
}

function seconds(number: number): number {
    return number * 1000;
}

function minutes(number: number): number {
    return seconds(number) * 60;
}
